import HeroImage from "assets/images/Hero-1.svg";
import HeroImage2 from "assets/images/Hero-2.svg";
import { NavLink } from "react-router-dom";
import ScrollReveal from "components/common/ScrollReveal";

const Hero = () => {
    const handleScrollDown = () => {
        window.scrollBy({
            top: window.innerHeight * 0.85,
            behavior: "smooth",
        });
    };

    return (
        <section className="hero polygon-big-bg gradient-mesh relative flex items-center pt-24 md:pt-28 lg:pt-32">
            <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 -left-20 w-72 h-72 bg-primary/10 rounded-full blur-3xl animate-pulse-soft" />
                <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-pulse-soft" />
            </div>

            <div className="container relative z-10">
                <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                    <ScrollReveal variant="left" className="order-2 lg:order-1">
                        <div className="max-w-xl mx-auto lg:mx-0 text-center lg:text-left">
                            <span className="section-eyebrow">Our Motivation</span>
                            <h1 className="font-bold text-4xl sm:text-5xl lg:text-[3.25rem] leading-tight mb-6 text-black">
                                Let&apos;s get{" "}
                                <span className="text-primary">IT</span> done.
                            </h1>
                            <p className="text-base md:text-lg text-secondary/80 leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
                                We strive to deliver excellence to our customers
                                and colleagues. Our values are the cornerstone
                                of all our actions and decisions.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                                <NavLink className="btn" to="/contact-us">
                                    Get Started
                                </NavLink>
                                <NavLink className="btn-outline" to="/about-us">
                                    About Us
                                </NavLink>
                            </div>
                        </div>
                    </ScrollReveal>

                    <ScrollReveal variant="right" delay={150} className="order-1 lg:order-2">
                        <div className="relative max-w-lg mx-auto lg:max-w-none">
                            <div className="relative z-10 animate-float-slow">
                                <img
                                    src={HeroImage}
                                    alt="Adroit Systems IT Services"
                                    className="w-full max-w-md mx-auto lg:max-w-none"
                                />
                            </div>
                            <div className="absolute -bottom-4 -right-4 md:bottom-8 md:-right-8 w-1/3 max-w-[160px] z-20 animate-float-delayed hidden sm:block">
                                <img
                                    src={HeroImage2}
                                    alt="Cloud and infrastructure solutions"
                                    className="w-full drop-shadow-lg rounded-2xl"
                                />
                            </div>
                            <div className="absolute -top-2 -left-2 md:top-4 md:-left-4 w-16 h-16 bg-primary/10 rounded-2xl rotate-12 hidden md:block" />
                            <div className="absolute bottom-1/3 -right-6 w-12 h-12 bg-primary/15 rounded-full hidden lg:block" />
                        </div>
                    </ScrollReveal>
                </div>
            </div>

            <button
                type="button"
                onClick={handleScrollDown}
                className="hero-scroll-hint"
                aria-label="Scroll down to explore more"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-5 h-5"
                    aria-hidden="true"
                >
                    <path d="M12 5v14" />
                    <path d="m19 12-7 7-7-7" />
                </svg>
            </button>
        </section>
    );
};

export default Hero;
